import './WithdrawModalStyle.scss';
import { Button, ButtonSize, FillType } from 'views/components/atoms/button';
import { ModalBase, ModalStyle } from 'views/components/atoms/modal';
import { AssetInfo } from '../Atoms/AssetIInfo';
import { formatNumber } from 'views/utils/format/FormatNumber';
import { formatDateToSlashDateTime } from 'views/utils/format/FormatDate';

type WithdrawModalProps = {
  isOpen: boolean;
  onRequestClose: () => void;
  withdrawAmount: number | undefined;
  withdrawDate: string | undefined;
  commission: number | undefined;
  reservedAmount?: number;
  transferAmount: number | undefined;
  onConfirm: () => void;
  disabled?: boolean;
};

const formatAssetAmount = (amount: number | undefined) => (amount === undefined ? '-' : formatNumber(amount));

export const WithdrawModal = (props: WithdrawModalProps) => {
  const {
    isOpen,
    onRequestClose,
    withdrawAmount,
    withdrawDate,
    commission,
    reservedAmount,
    transferAmount,
    onConfirm,
    disabled,
  } = props;

  return (
    <ModalBase
      isOpen={isOpen}
      modalStyle={ModalStyle.confirmModal}
      onRequestClose={onRequestClose}
      children={
        <>
          {reservedAmount && (
            <div className="reservation">
              <AssetInfo label="変更前出金予約受付金額" amount={formatAssetAmount(reservedAmount)} />
            </div>
          )}
          <div className="reservation">
            <AssetInfo label="出金予約受付金額(出金予定額)" amount={formatAssetAmount(withdrawAmount)} />
            <div className="reservation_date">({formatDateToSlashDateTime(withdrawDate, false)})</div>
          </div>
          <div className="reservation_uchiwake">【内訳】</div>
          <div className="reservation_detail">
            <AssetInfo label="振込予定額" amount={formatAssetAmount(transferAmount)} />
          </div>
          <div className="reservation_detail">
            <AssetInfo label="振込手数料" amount={formatAssetAmount(commission)} />
          </div>
          <div className="establishWrapper">
            <div className="establishWrapper_announce">
              <span>
                ＜ご注意＞
                <br />
                ・出金予約の取消は毎週木曜日12時に締め切ります
                <br />
                ・出金確定後の取消は行えませんのでご注意ください
                <br />
                ・出金に伴う手数料はお客様負担となりますので予めご了承ください
                <br />
                ※出金手数料は一律440円です
              </span>
            </div>
          </div>
          <div className="reservation_actions">
            <Button
              label="出金予約をする"
              buttonSize={ButtonSize.sizeM}
              fillType={FillType.primaryFill}
              onClick={onConfirm}
              disabled={disabled}
            />
            <Button
              label="戻る"
              buttonSize={ButtonSize.sizeM}
              fillType={FillType.primaryEmpty}
              onClick={onRequestClose}
              disabled={disabled}
            />
          </div>
        </>
      }
    />
  );
};
